import script from "./EditItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EditItem.vue?vue&type=script&setup=true&lang=js"

import "./EditItem.vue?vue&type=style&index=0&id=0e6193bf&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e6193bf"]])

export default __exports__